const ActionToolEnum = {
  bulk_operation: "bulk_operation",
  export_report: "export_report",
  import_export_geozones: "import_export_geozones",

  import_tracker_settings: "import_tracker_settings",
  import_cellular: "import_cellular",
  export_cellular: "export_cellular",
  test_cellular: "test_cellular",
  import_infrastructure_settings: "import_infrastructure_settings",
  // WiFi page actions
  add_mac_address: "add_mac_address",
  test_mac_address: "test_mac_address",
  export_private_wifi: "export_private_wifi",
  import_blocked_wifi: "import_blocked_wifi",
  export_blocked_wifi: "export_blocked_wifi",
  test_blocked_wifi: "test_blocked_wifi",
  private_wifi_page: "private_wifi_page",
  blocked_wifi_page: "blocked_wifi_page",
  unresolved_wifi_page: "unresolved_wifi_page",
  clear_all_unresolved_wifi: "clear_all_unresolved_wifi",
  export_unresolved_wifi: "export_unresolved_wifi",
  // Cell tower actions
  cell_tower_analysis: "cell_tower_analysis",
  cell_tower_cleanup: "cell_tower_cleanup",
  cell_tower_review: "cell_tower_review",
  // Impartner actions
  sync_sensolus_users_to_impartner: "sync_sensolus_users_to_impartner",
} as const;

export type ActionToolEnumType = typeof ActionToolEnum[keyof typeof ActionToolEnum];

export default ActionToolEnum;
